import axios from "axios";
import Cookies from "js-cookie";

const GetSiteRec = async (id) => {
    const headers = { "Authorization": "BEARER authToken=" + Cookies.get('skyarc-auth-8080'), "Accept":"application/json" }    
    const dataResponse = await axios.get(`https://infinity.skyspark.nl/api/portal/eval?expr=inf_api_sites(@${id})`,{
        headers
    })
    return dataResponse
}
export default GetSiteRec;